<template>
  <b-overlay :show="loading">
  <!-- eslint-disable -->
  <div class="vx-card">
  <div class="vx-card__header row">
    <div class="col-12 col-md-6">
      <h4 class="text-primary">Roles</h4>
    </div>
  </div>
  <div class="vx-card__collapsible-content vs-con-loading__container">
  <div class="vx-card__body">
  <div class="row">
    <div class="col-12 col-md-3">
      <select
          class="form-control"
          v-model="filtros.app"
          v-on:change="applyFilters()"
      >
        <option value="">Todos</option>
        <option
            v-for="{id,title} in applications"
            :value="id"
        >
          {{ title }}
        </option>
      </select>
    </div>
    <div class="col-12 col-md-2">
      <input
          class="form-control"
          v-model="filtros.permiso"
          placeholder="Busque permiso"
          v-on:change="applyFilters()"
          v-on:enter="applyFilters()"
      >
    </div>
    <div class="col-12 col-md-5">
      <input
          class="form-control"
          v-model="filtros.nombre"
          placeholder="Busque un rol"
          v-on:change="applyFilters()"
          v-on:enter="applyFilters()"
      >
    </div>
    <div class="col-12 col-md-2">
      <button
          class="btn btn-primary"
          v-tooltip="'Agregar rol'"
          v-on:click="addNNewRol()"
          data-cy="add-rol"
          v-has-permission="'WAR100'"
      >
        <feather-icon icon="PlusIcon"/>
      </button>
      <button
        class="btn btn-secondary ml-10"
        v-tooltip="'Descargar CSV'"
        v-on:click="downloadReport()"
        data-cy="download-rol"
        v-has-permission="'WAR106'"
      >
        <feather-icon icon="DownloadIcon"/>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <ul class="list-group mt-5">
        <li
            :key="'role-'+role.rolId"
            :id="'role-'+role.rolId"
            v-for="role in roles"
            class="list-group-item "
        >
          <div class="actions cursor-pointer">
            <feather-icon
                class="icon"
                size="18"
                icon="EditIcon"
                color="green"
                v-tooltip="'Editar rol'"
                v-on:click="editRol(role)"
                data-cy="edit-rol-info"
                v-has-permission="'WAR101'"
            />
            <feather-icon
                class="icon"
                size="18"
                icon="KeyIcon"
                v-tooltip="'Editar Permisos'"
                v-on:click="editRolPermission(role)"
                data-cy="get-rol-info"
                v-has-permission="'WAR103'"
            />
            <feather-icon
                class="icon"
                size="18"
                icon="SendIcon"
                v-tooltip="'Migrar rol'"
                v-on:click="migrateRol(role)"
                data-cy="migrate-rol"
                v-has-permission="'FEB99'"
            />
            <feather-icon
                class="icon"
                size="18"
                icon="DeleteIcon"
                color="red"
                v-tooltip="'Eliminar rol'"
                v-on:click="deleteRol(role)"
                data-cy="delete-rol"
                v-has-permission="'WAR102'"
            />
            <feather-icon
                class="icon"
                size="18"
                icon="CopyIcon"
                color="primary"
                v-tooltip="'Copiar rol'"
                v-on:click="copyRol(role)"
                data-cy="copy-rol"
                v-has-permission="'FEB99'"
            />
          </div>
          <div class="row">
            <div class="col-md-8 col-12">
              <b>Nombre: </b> {{ role.nombre }}
            </div>
            <div class="col-md-3 col-12">
              <b>APP: </b><span
                class="badge"
                :style="{backgroundColor:applicationColor(role.app)}"
            >
                      {{ applicationName(role.app) }}
                    </span>

            </div>
            <div class="col-md-8 col-12 mt-2">
              <div class="about pr-3">
                <b>Descripción: </b> {{ role.descripcion }}
              </div>
            </div>
            <div class="col-md-3 col-12">
              <b>Ámbito: </b> {{ role.ambito }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <pagination
      :value="page"
      :pages="totalPages"
      @input="pageChanged"
  />
  </div>
  </div>
  </div>
  <rol-modal
      ref="rolModal"
      @saveRol="listRoles()"
  />
  <rol-copy-modal
      ref="rolCopyModal"
      @saveRol="listRoles()"
  />
  <rol-delete-modal
      ref="rolDeleteModal"
      @deleteRol="listRoles()"
  />
  <rol-permission-modal ref="rolPermissionModal"/>
  <rol-migration-modal ref="rolMigrationModal"/>
  </b-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

import { applications } from '@/febos/global/utils/configurations';
import { ioListCompanyRole } from '@/febos/servicios/api/empresas.api';
import Pagination from '@/febos/global/empresas/componentes/roles/Pagination';
import RolModal from '@/febos/global/empresas/componentes/roles/RolModal';
import RolPermissionModal from '@/febos/global/empresas/componentes/roles/RolPermissionModal';
import RolMigrationModal from '@/febos/global/empresas/componentes/roles/RolMigrationModal';
import RolCopyModal from '@/febos/global/empresas/componentes/roles/RolCopyModal';
import RolDeleteModal from '@/febos/global/empresas/componentes/roles/RolDeleteModal';
import clienteFebosAPI from '@/febos/servicios/clienteFebosAPI';

export default {
  name: 'Configuraciones',
  components: {
    Pagination,
    RolModal,
    RolPermissionModal,
    RolMigrationModal,
    RolCopyModal,
    RolDeleteModal
  },
  data() {
    return {
      applications,
      loading: false,
      roles: [],
      page: 1,
      totalRoles: 0,
      totalPages: 1,
      limit: 10,
      filtros: {
        app: process.env.VUE_APP_APP || 'ED',
        permiso: undefined
      }
    };
  },
  mounted() {
    this.listRoles();
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    applicationName() {
      return (applicationID) => this.applications.find((app) => app.id === applicationID)?.title;
    },
    applicationColor() {
      return (applicationID) => this.applications.find((app) => app.id === applicationID)?.color;
    }
  },
  methods: {
    async listRoles() {
      this.loading = true;
      try {
        const response = await ioListCompanyRole(
          {
            companyId: this.company.id,
            page: this.page,
            limit: this.limit,
            filters: this.getFilters(),
            permiso: this.filtros.permiso
          }
        );
        const {
          roles,
          paginaActual,
          totalElementos,
          totalPaginas
        } = response.data;
        this.roles = roles;
        this.page = paginaActual;
        this.totalRoles = totalElementos;
        this.totalPages = totalPaginas;
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    applyFilters() {
      this.page = 1;
      this.listRoles();
    },
    getFilters() {
      return Object.entries(this.filtros).map(([key, value]) => {
        if (!value) {
          return '';
        }
        if (key === 'nombre') {
          return `${key}$${value}`;
        }
        return `${key}:${value}`;
      }).filter((item) => !!item).join('|');
    },
    pageChanged(page) {
      this.page = page;
      this.listRoles();
    },
    editRol(role) {
      this.$refs.rolModal.open(role);
    },
    addNNewRol() {
      this.$refs.rolModal.open();
    },
    downloadReport() {
      const toastModal = this.$bvToast.toast(
        'Se está descargando su archivo',
        {
          title: '¡Danos unos segundos!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      clienteFebosAPI.get(`/v2/empresas/${ this.company.id}/roles/reporte`).then((response) => {
        if (response.data.codigo === 10) {
          window.open(response.data.url);
          this.$bvToast.hide(toastModal);
          this.$bvToast.toast(
            'El archivo se ha descargado exitosamente',
            {
              title: '¡Éxito!',
              variant: 'success',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 3000
            }
          );
        }
      }).catch((error) => {
        this.$vs.loading.close();
        window.console.log(error);
        this.$bvToast.toast(
          'No fue posible descargar el reporte',
          {
            title: 'Error',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000
          }
        );
      });
    },
    editRolPermission(role) {
      this.$refs.rolPermissionModal.open(role);
    },
    copyRol(role) {
      this.$refs.rolCopyModal.open(role);
    },
    migrateRol(role) {
      this.$refs.rolMigrationModal.open(role);
    },
    async deleteRol(role) {
      this.$refs.rolDeleteModal.open(role);
    }
  }
};
</script>

<style scoped>
.actions {
  position: relative;
  float: right;
}

.icon {
  margin-right: 5px;
}
</style>
